import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Empregador, Funcionario, JornadaPonto } from '../../api.service';

@Component({
  selector: 'app-painel-dados-funcionario',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-dados-funcionario.component.html'
})
export class PainelDadosFuncionarioComponent {
  @Input({ required: true }) funcionario!: Funcionario;
  @Input() empregadores: Empregador[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() jornadas: JornadaPonto[] = [];
  @Input() empregadorSelecionado = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() funcionarioChange = new EventEmitter<Funcionario>();
  @Output() digitouCpf = new EventEmitter<void>();

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.alterarEmpregador.emit();
  }

  alterarCpf(valor: string) {
    this.funcionario.cpf = valor;
    this.digitouCpf.emit();
    this.emitirFuncionario();
  }

  alterarDepartamento(departamentoId: string) {
    this.funcionario.departamentoId = departamentoId;
    const departamento = this.departamentos.find(item => item.id === departamentoId);
    this.funcionario.departamento = departamento?.nome || '';
    this.emitirFuncionario();
  }

  emitirFuncionario() {
    this.funcionarioChange.emit(this.funcionario);
  }
}
